import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../components/snackbar/snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {

  constructor(private _snackBar: MatSnackBar) { }

  public openCustomSnackBar(message: string,
    type: any,
    duration?,
    verticalPosition?: any,
    horizontalPosition?: any,
    className?: any) {
    const _snackType = type !== undefined ? type : 'success';
    this._snackBar.openFromComponent(SnackbarComponent, {
      duration: duration || 5000,
      horizontalPosition: horizontalPosition || 'center',
      verticalPosition: verticalPosition || 'top',
      panelClass: className,
      data: { message: message, snackType: _snackType, snackBar: this._snackBar }
    });
  }
}